import React from 'react'
import PropTypes from 'prop-types'

import { get } from 'lodash'

import Icon from '../components/Icon'

const MenuIcon = ({ icon }) => {
    if (!icon) {
        return null
    }
    const iconElement = React.isValidElement(icon) ? icon : <Icon name={ icon } />
    return React.cloneElement(iconElement, { ...get(icon, 'props', {}), size: 20, className: 'md-mr-10' })
}

MenuIcon.propTypes = {
    icon: PropTypes.node
}

export default MenuIcon
